import styled from 'styled-components';

const ImageSlideWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export default ImageSlideWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/ImageSlideWrapper.jsx